import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input']

  connect() {
    const substringMatcher = function(strs) {
      return function findMatches(q, cb) {
        let matches, substrRegex;

        if (q === '') {
          cb(teeth)
        }

        matches = [];

        substrRegex = new RegExp(q, 'i');

        $.each(strs, function(i, str) {
          if (substrRegex.test(str)) {
            matches.push(str);
          }
        });

        cb(matches);
      };
    };

    const teeth = [
      '11', '12', '13', '14', '15', '16', '17', '18',
      '21', '22', '23', '24', '25', '26', '27', '28',
      '31', '32', '33', '34', '35', '36', '37', '38',
      '41', '42', '43', '44', '45', '46', '47', '48',
      '51', '52', '53', '54', '55',
      '61', '62', '63', '64', '65',
      '71', '72', '73', '74', '75',
      '81', '82', '83', '84', '85',
      'Maxila', 'Mandíbula', 'Face', 'Arcada Superior', 'Arcada Inferior',
      'Arcadas'
    ];

    // let $typeahead = $(this.inputTarget).typeahead(
    //   {
    //     minLength: 0,
    //   },
    //   {
    //     name: 'teeth',
    //     source: substringMatcher(teeth),
    //   }
    // )
  }

  teardown() {
    $('.tt-input').typeahead('destroy')
  }
}
